angular.module('user-group', ['core'])
    .constant('UserGroupConst', {
        eventUpdate: 'usergroup.updated'
    })
    .factory('UserGroup', function ($resource) {
        return $resource('/crm/api/user-group/:id', {}, {
            list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            autocomplete: {url: '/crm/api/user-group/autocomplete', method: 'get', isArray: true}
        })
    })
    .service('UserGroupService', function ($rootScope, toastr, modals, UserGroup, UserGroupConst) {
        this.findByName = name => {
            return UserGroup.autocomplete({name: name}).$promise.then(items => {
                if (items.length === 1) {
                    return items[0]
                }
                return null
            })
        }
        this.edit = id => UserGroup.get({id: id}).$promise.then(entity => this.editModal(entity))
        this.editModal = entity => {
            return modals.open('app/user-group/edit-modal.html', 'UserGroupDialogController', entity, {size: 'md'}, "$ctrl")
        }
        this.addModal = () => {
            let entity = {
                id: null
            }
            return this.editModal(entity)
        }
        this.remove = item => {
            return modals.confirmDelete(item.name, () => UserGroup.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(UserGroupConst.eventUpdate)))
        }
    })
    .component('userGroupListView', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/user-group/list.html',
        controller: function ($scope, $state, UserGroup, UserGroupService, UserGroupConst) {
            this.UserGroupService = UserGroupService
            this.reset = () => this.filters = {}

            $scope.$on(UserGroupConst.eventUpdate, () => $state.reload())
        }
    })
    .controller('UserGroupDialogController', function ($timeout, $scope, $rootScope, $uibModalInstance, data, toastr, UserGroup, UserGroupConst, Principal) {
        this.item = data

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = UserGroup.update(this.item).$promise
            } else {
                promise = UserGroup.save(this.item).$promise
            }
            return promise.then(result => {
                    $rootScope.$broadcast(UserGroupConst.eventUpdate)
                    Principal.refreshIdentity()
                    $uibModalInstance.close(result)
                    toastr.success("Zapisano")
                })
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('userGroupList', {
            parent: 'app',
            url: '/user-group?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_USER_MANAGEMENT']
            },
            views: {
                'content@': "userGroupListView"
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (UserGroup, $stateParams) => UserGroup.list(angular.copy($stateParams)).$promise
            }
        })
    })
